import { render, staticRenderFns } from "./CustomSwitch.vue?vue&type=template&id=1f3ce1e8&"
import script from "./CustomSwitch.vue?vue&type=script&lang=ts&"
export * from "./CustomSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports